import React, { useState } from "react";
import "../css/ExpenseFrom.css";

export default function ExpenseFrom(props) {
  const [enteredTitle, setEnteredTitle] = useState("");
  // ? event object is returned on every event listener use
  const titleChangeHandler = (event) => {
    setEnteredTitle(event.target.value);
  };

  const [enteredAmount, setEnteredAmount] = useState("");
  const amountChangeHandler = (event) => {
    setEnteredAmount(event.target.value);
  };

  const [enteredDate, setEnteredDate] = useState("");
  const dateChangeHandler = (event) => {
    setEnteredDate(event.target.value);
    console.log(event.target.value);
  };

  const submitHandler = (event) => {
    // ! this method prevent page to be reloded and it is in javascrit
    event.preventDefault();

    const expenseData = {
      title: enteredTitle,
      amount: +enteredAmount,
      date: new Date(enteredDate),
    };
    // console.log(expenseData);
    props.onSaveExpenseData(expenseData);

    // ! after two way binding we are setting the values to empty strings
    setEnteredAmount("");
    setEnteredTitle("");
    setEnteredDate("");
  };

  return (
    <>
      <form onSubmit={submitHandler}>
        <div className="new-expense__controls">
          <div className="new-expense__control">
            <label>Title</label>
            <input
              type="text"
              value={enteredTitle}
              onChange={titleChangeHandler}
            ></input>
          </div>
        </div>
        <div className="new-expense__controls">
          <div className="new-expense__control">
            <label>Amount</label>
            <input
              type="number"
              value={enteredAmount}
              min="0.01"
              step="0.01"
              onChange={amountChangeHandler}
            ></input>
          </div>
        </div>
        <div className="new-expense__controls">
          <div className="new-expense__control">
            <label>Date</label>
            <input
              type="date"
              value={enteredDate} // ! here we are passing value attribute to reset the value it is also knwon as two way binding
              min="2019-01-01"
              max="2022-12-31"
              onChange={dateChangeHandler}
            ></input>
          </div>
        </div>
        <div className="new-expense__actions">
          {/* ? we can also add onClick here */}
          <button type="submit" onClick={props.onCancel}>
            Cancel
          </button>
          <button type="submit">Add expense</button>
        </div>
      </form>
    </>
  );
}
